<template>
  <div>
    <div class="bar" :class="{ 'scroll-shadow': scrolled }">
      <div class="content">
        <h2>NOTICE OF PRACTICE CLOSURE:</h2>
        Painmedics and Dr. Harpavat announce the permanent closure of this
        practice on <b>December 15, 2025</b>.
        <br /><br />
        With written authorization, a copy of medical records will be available
        to you or can be forwarded to a physician of your choosing.
        <br />
        Please fill out the
        <a href="./forms/MedicalRecordReleaseForm_20251006.pdf" target="_blank">
          Medical Record Release Authorization
        </a>
        form to authorize Painmedics to release medical records to your
        physician.
        <br /><br />
        Please contact your insurance company and your primary care provider for
        timely referral to a physician of your choice
        <br />
        for continuing care beyond the dates mentioned.
        <br /><br />
        Thank you for your support.
        <br />
         
        <br />
        Phone Number: <b>(469) 541-1613</b> | Fax: <b>(469) 541-1614</b>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NoticeBanner",
  data() {
    return {
      scrolled: false
    };
  },
  mounted() {
    window.addEventListener("scroll", this.onScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.onScroll);
  },
  methods: {
    onScroll() {
      // Get the current scroll position
      const currentScrollPosition =
        window.pageYOffset || document.documentElement.scrollTop;

      // Because of momentum scrolling on mobiles, we shouldn't continue if it is less than zero
      if (currentScrollPosition < 0) {
        return;
      }

      // Here we determine whether we need to show or hide the navbar
      this.scrolled = currentScrollPosition !== 0;
    }
  }
};
</script>

<style scoped>
.bar {
  width: 100%;
  height: 23vw;
  overflow: hidden;
  display: block;
  left: 0;
  background-color: #1976d2;
  color: white;
  float: right;
  transition: 0.3s;
}

.scroll-shadow {
  box-shadow: 0px 6px 17px 0px rgba(181, 181, 181, 0.25);
}

.content {
  opacity: 1;
  vertical-align: center;
  padding-top: 1.5%;
  font-size: 1vw;
}

.vertical-spacer {
  width: 1%;
  display: block;
  height: 2vw;
  float: left;
}
</style>
